import { render, staticRenderFns } from "./DynaFormWidget.vue?vue&type=template&id=449b3a1c&"
import script from "./DynaFormWidget.vue?vue&type=script&lang=js&"
export * from "./DynaFormWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports